// Timeout values in milliseconds
export const TIMEOUTS = {
  MESSAGE_DISMISS: 3000,
  MESSAGE_DISMISS_SHORT: 2000,
  MESSAGE_DISMISS_LONG: 5000,
  AUTH_RETRY_DELAY: 500,
  PAGE_RELOAD_DELAY: 2000,
} as const

// Undo window
export const UNDO_WINDOW_MS = 60 * 60 * 1000 // 1 hour

// File upload limits
export const LIMITS = {
  MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024, // 10MB
} as const

// Number formatting precision
export const PRECISION = {
  BATTERY_SOC: 2,
  BATTERY_VOLTAGE: 3,
  BATTERY_CURRENT: 1,
  TEMPERATURE: 1,
  LOCATION: 6,
  POWER_WATTS: 0,
  CURRENCY: 2,
} as const

// Dashboard thresholds
export const THRESHOLDS = {
  BATTERY_DANGER: 20,
  BATTERY_WARNING: 40,
  FRESH_WATER_DANGER: 20,
  FRESH_WATER_WARNING: 40,
  GREY_WATER_DANGER: 80,
  GREY_WATER_WARNING: 60,
  GREY_WATER_FULL: 100,
  RUNTIME_HOURS_FOR_DAYS: 36,
  STALENESS_MINUTES: 2,
  SENSOR_BATTERY_LOW: 20,
  FUEL_LEVEL_DANGER: 12,
  FUEL_LEVEL_WARNING: 25,
  ADBLUE_LEVEL_DANGER: 10,
  ADBLUE_LEVEL_WARNING: 20,
  DPF_SOOT_WARNING: 50,
  DPF_SOOT_DANGER: 80,
} as const

// Interval values in milliseconds
export const INTERVALS = {
  STALENESS_CHECK: 30000,
} as const

// WebSocket reconnection
export const WEBSOCKET = {
  INITIAL_RECONNECT_DELAY: 1000 as number,
  MAX_RECONNECT_DELAY: 30000 as number,
  RECONNECT_MULTIPLIER: 2 as number,
}

// Validation
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 4,
  USERNAME_PATTERN: /^[a-zA-Z0-9_-]+$/,
  BATTERY_AVG_WINDOW_MIN: 1,
  BATTERY_AVG_WINDOW_MAX: 600,
  DB_WRITE_INTERVAL_MIN: 1,
  DB_WRITE_INTERVAL_MAX: 30,
} as const

// Supported currencies
export const CURRENCIES = [
  { code: 'DKK', name: 'Danish Krone' },
  { code: 'EUR', name: 'Euro' },
  { code: 'SEK', name: 'Swedish Krona' },
  { code: 'NOK', name: 'Norwegian Krone' },
  { code: 'GBP', name: 'British Pound' },
  { code: 'USD', name: 'US Dollar' },
  { code: 'CHF', name: 'Swiss Franc' },
  { code: 'PLN', name: 'Polish Zloty' },
  { code: 'CZK', name: 'Czech Koruna' },
] as const

// Currency codes only (for simpler dropdowns)
export const CURRENCY_CODES = CURRENCIES.map(c => c.code)

// Default currency
export const DEFAULT_CURRENCY = 'DKK'

// Accepted image types for uploads
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const

// Event type display info
export const EVENT_TYPES = {
  shower: { icon: '🚿', label: 'Shower' },
  water_refill: { icon: '💧', label: 'Water Refill' },
  grey_empty: { icon: '🚰', label: 'Grey Water Emptied' },
  refuel: { icon: '⛽', label: 'Refuel' },
  propane_replace: { icon: '🔥', label: 'Propane Replace' },
  adblue_refill: { icon: '💎', label: 'AdBlue Refill' },
  vehicle_expense: { icon: '🔧', label: 'Vehicle Expense' },
  custom: { icon: '📝', label: 'Custom Event' },
} as const

// Vehicle expense types
export const EXPENSE_TYPES = ['Maintenance', 'Repair', 'Parts', 'Other'] as const

// Vehicle expense categories
export const EXPENSE_CATEGORIES = [
  'Engine',
  'Transmission',
  'Brakes',
  'Suspension',
  'Electrical',
  'Body',
  'Interior',
  'Tires',
  'Fluids',
  'Service',
  'Other',
] as const
